import { createRoutine } from 'redux-saga-routines';

export const fetchAllEmailTemplate = createRoutine('FETCH_ALL_EMAIL_TEMPLATE');
export const fetchPartialEmailTemplates = createRoutine(
  'FETCH_PARTIAL_EMAIL_TEMPLATES'
);
export const fetchEmailTemplateById = createRoutine(
  'FETCH_EMAIL_TEMPLATE_BY_ID'
);
export const createEmailTemplate = createRoutine('CREATE_EMAIL_TEMPLATE');
export const deleteEmailTemplate = createRoutine('DELETE_EMAIL_TEMPLATE');
export const updateEmailTemplate = createRoutine('UPDATE_EMAIL_TEMPLATE');

export const duplicateEmailTemplate = createRoutine('DUPLICATE_EMAIL_TEMPLATE');
export const resetSelectedEmailTemplate = createRoutine(
  'RESET_SELECTECTED_EMAIL_TEMPLATE'
);
